import type { Pair } from '../messages';

/** Theme picker options and their hints. */
export const theme = {
  'theme.night': ['Ночь', 'Night'],
  'theme.nightHint': ['Спокойный сине-серый фон и светлые обложки.', 'Calm blue-grey background, light covers.'],
  'theme.day': ['День', 'Day'],
  'theme.dayHint': ['Тот же характер, но светлый.', 'The same character, in light.'],
  'theme.system': ['Как в системе', 'System'],
  'theme.systemHint': ['Следует настройкам устройства.', 'Follows your device setting.'],
} satisfies Record<string, Pair>;
